module.exports = __webpack_public_path__ + "img/ico_guide.77c8a772.svg";